import axios from "axios";
import { GET_EXCEL_REPORTS, GET_EXCEL_PROGRESS_REPORTS, GET_MODULE_PDF, GET_WEBINAR_DOCUMENT,GET_MODULE_PDF_FN,GET_MODULE_PDF_SP,GET_SUMMARY_PAGE_PDF,GET_ZIP_FOR_ALL_MODULES,GET_OTHER_DOCUMENTS} from '../../constants/api';
import { ShowException } from '../utils/tostar';
// import { number } from 'prop-types';

export const downloadExcelCall = (data: any) => {
    const resp = axios.post(GET_EXCEL_REPORTS, data.payload, { responseType: 'blob' })
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const downloadZipCall = (data:any) => {
    const resp = axios.post(GET_ZIP_FOR_ALL_MODULES,data.payload, { responseType: 'blob' })
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const getProgresReportCall = (survey: any) => {
    return axios.get(GET_EXCEL_PROGRESS_REPORTS + "?surveyId=" + survey.id, { responseType: 'arraybuffer' })
        .then((resp: any) => {
            if (resp && resp.data) {
                const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', survey.title + 'ProgressReport' + '.xlsx');
                document.body.appendChild(link);
                link.click();
            }
            return resp;
        }, (err: any) => {
            ShowException(err);
            return err;
        })
}

export const downloadModulePdf = (moduleId: any) => {
    return axios.get(GET_MODULE_PDF + moduleId, { responseType: 'blob' })
        .then((resp: any) => {
            if (resp && resp.data) {
                console.log(resp);
                const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Module' + '.pdf');
                document.body.appendChild(link);
                link.click();
            }
            return resp;
        })
        .catch((err) => {
            ShowException(err);
        });
}

// Download PDF file for French Language
export const downloadModulePdfFn = (moduleId: any) => {
    return axios.get(GET_MODULE_PDF_FN + moduleId, { responseType: 'blob' })
        .then((resp: any) => {
            if (resp && resp.data) {
                console.log(resp);
                const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Module' + '.pdf');
                document.body.appendChild(link);
                link.click();
            }
            return resp;
        })
        .catch((err) => {
            ShowException(err);
        });
}

// Download PDF file for Spanish language
export const downloadModulePdfSp = (moduleId: any) => {
    return axios.get(GET_MODULE_PDF_SP + moduleId, { responseType: 'blob' })
        .then((resp: any) => {
            if (resp && resp.data) {
                console.log(resp);
                const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Module' + '.pdf');
                document.body.appendChild(link);
                link.click();
            }
            return resp;
        })
        .catch((err) => {
            ShowException(err);
        });
}

export const DownloadSummaryPagePDF = () => {
    return axios.get(GET_SUMMARY_PAGE_PDF , { responseType: 'blob' })
        .then((resp: any) => {
            if (resp && resp.data) {
                console.log(resp);
                const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'SummaryPage' + '.pdf');
                document.body.appendChild(link);
                link.click();
            }
            return resp;
        })
        .catch((err) => {
            ShowException(err);
        });
}

export const downloadWebinarDocument = (webinarId: number) => {
    return axios.get(GET_WEBINAR_DOCUMENT + webinarId, { responseType: 'blob' })
        .then((resp: any) => {
            if (resp && resp.data) {
                console.log(resp);
                const url = window.URL.createObjectURL(new Blob([resp.data], { type: webinarId === 1 ? 'application/msword' : (webinarId === 2 || webinarId === 3 || webinarId === 4 ? 'application/pdf' : 'video/mp4') }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Webinar' + (webinarId === 1 ? '.docx' : (webinarId === 2 || webinarId === 3 || webinarId === 4) ? '.pdf' : '.mp4'));
                document.body.appendChild(link);
                link.click();
            }
            return resp;
        })
        .catch((err) => {
            ShowException(err);
        });
}

export const downloadWebinarZipDocument = (webinarId: number, fileName: string) => {
    return axios.get(GET_WEBINAR_DOCUMENT + webinarId, { responseType: 'blob' })
        .then((resp: any) => {
            if (resp && resp.data) {
                console.log(resp);
                const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/zip' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            }
            return resp;
        })
        .catch((err) => {
            ShowException(err);
        });
}

export const downloadOtherDocumentsPdf = (moduleId: any) => {
    return axios.get(GET_OTHER_DOCUMENTS + moduleId, { responseType: 'blob' })
        .then((resp: any) => {
            if (resp && resp.data) {
                console.log(resp);
                const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Nutridash Report' + '.pdf');
                document.body.appendChild(link);
                link.click();
            }
            return resp;
        })
        .catch((err) => {
            ShowException(err);
        });
}


// WEBPACK FOOTER //
// ./src/effects/api/api.report.tsx